<template>
    <div class="xc-page">
        <div class="xc-page-main">
            <!-- 面包屑 -->
            <div class="xc-breadcrumb">
                <router-link :to="$config.adminPath + '/system/account/setting'">系统设置</router-link>
                <a>菜单管理</a>
            </div>
            <div class="xc-row xc-s-flex">
                <div class="xc-card">
                    <div class="xc-card-content">
                        <div class="modules">
                            <div class="body">
                                <template v-if="list.length">
                                    <xc-tree
                                        :data.sync="list"
                                        label="label"
                                        @rightClick="rightClick"
                                        ref="groupTree">
                                    </xc-tree>
                                    <div ref='treeEdit' class="xc-tree-edit" v-show="showTreeEdit" @click.stop="">
                                        <ul>
                                            <li @click="openEditGroup('add')">添加菜单</li>
                                            <li @click="openEditGroup('addChild')" v-show="module.type!=2">添加子菜单</li>
                                            <li @click="openEditGroup('edit')">编辑菜单</li>
                                            <li @click="openEditGroup('delete')">删除菜单</li>
                                        </ul>
                                    </div>
                                </template>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <!--弹窗-->
        <div class="xc-card">
            <!--添加-->
            <div class="xc-modal xc-modal-dialog" v-if="modalName=='add'">
                <div class="xc-modal-mask" @click="modalName==null">
                    <div class="xc-modal-wrap xc-anim-scaleIn">
                        <div class="xc-modal-content">
                            <div class="xc-modal-header">
                                <div class="xc-modal-title">添加菜单</div>
                                <div class="xc-modal-close" @click="modalName=null"></div>
                            </div>
                            <div class="xc-modal-body">
                                <form class="xc-form" name="add" data-vv-scope="add">
                                    <div class="xc-form-inline">
                                        <xc-form-item label="上级模块">
                                            <input type="hidden" name="parentId" :value="module.pid">
                                            <input type="text" name="parentName" :value="module.pName" class="xc-input xc-input-disabled" disabled/>
                                        </xc-form-item>
                                        <xc-form-item label="模块名称" required :error="errors.first('moduleName','add')">
                                            <input type="text" name="moduleName" class="xc-input" v-validate="'required'" data-vv-as="模块名称"/>
                                        </xc-form-item>
                                    </div>
                                    <div class="xc-form-inline">
                                        <xc-form-item label="模块类别" required :error="errors.first('type','add')">
                                            <label class="xc-checkbox-wrap" v-if="module.level<=1">
                                                <input type="radio" name="type" class="xc-radio" value="1" :checked="true" @click="selectType($event)" v-validate="'required'" data-vv-as="模块类别"/>
                                                <span class="xc-checkbox-label">菜单</span>
                                            </label>
                                            <label class="xc-checkbox-wrap" v-if="module.level!=0">
                                                <input type="radio" name="type" class="xc-radio" value="2" :checked="!isShow" @click="selectType($event)" v-validate="'required'" data-vv-as="模块类别"/>
                                                <span class="xc-checkbox-label">按钮</span>
                                            </label>
                                        </xc-form-item>
                                        <xc-form-item label="状态" required :error="errors.first('status','add')">
                                            <label class="xc-checkbox-wrap">
                                                <input type="radio" name="status" class="xc-radio" :checked="true" value="1" v-validate="'required'" data-vv-as="状态"/>
                                                <span class="xc-checkbox-label">启用</span>
                                            </label>
                                            <label class="xc-checkbox-wrap">
                                                <input type="radio" name="status" class="xc-radio" value="0" v-validate="'required'" data-vv-as="状态"/>
                                                <span class="xc-checkbox-label">禁用</span>
                                            </label>
                                        </xc-form-item>

                                    </div>
                                    <xc-form-item label="备注">
                                        <input type="text" name="moduleDesc" class="xc-input"/>
                                    </xc-form-item>
                                    <div class="xc-form-inline">
                                        <xc-form-item label="url" :error="errors.first('url','add')">
                                            <input type="text" name="url" placeholder="例如/a/b/c" class="xc-input" v-validate="'href'" data-vv-as="url"/>
                                        </xc-form-item>
                                    </div>
                                    <template v-if="isShow && module.level==0">
                                        <div class="xc-form-inline">
                                            <xc-form-item label="icon" >
                                                <input type="hidden" name="defaultIcon" class="xc-input"/>
                                                <xc-upload
                                                    :fileList.sync="inactive"
                                                    :beforeUpload="beforeUpload"
                                                    :uploadSuccess="uploadSuccess"
                                                    type="3"
                                                    accept="image/*"
                                                    :url="uploadUrl"
                                                />
                                            </xc-form-item>
                                            <xc-form-item label="选中的icon" >
                                                <input type="hidden" name="lightIcon" class="xc-input"/>
                                                <xc-upload
                                                    :fileList.sync="active"
                                                    :beforeUpload="beforeUpload"
                                                    :uploadSuccess="uploadSuccess"
                                                    type="3"
                                                    accept="image/*"
                                                    :url="uploadUrl"
                                                />
                                            </xc-form-item>
                                        </div>
                                    </template>

                                </form>
                            </div>
                            <div class="xc-modal-footer xc-flex-center">
                                <div class="xc-btn-group">
                                    <button type="button" class="xc-btn xc-btn-primary" @click="add">确定</button>
                                    <button type="button" class="xc-btn xc-btn-default" @click="modalName=null">取消</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--添加子菜单-->
            <div class="xc-modal xc-modal-dialog" v-if="modalName=='addChild'">
                <div class="xc-modal-mask" @click="modalName==null">
                    <div class="xc-modal-wrap xc-anim-scaleIn">
                        <div class="xc-modal-content">
                            <div class="xc-modal-header">
                                <div class="xc-modal-title">添加子菜单</div>
                                <div class="xc-modal-close" @click="modalName=null"></div>
                            </div>
                            <div class="xc-modal-body">
                                <form class="xc-form" name="addChild" data-vv-scope="addChild">
                                    <div class="xc-form-inline">
                                        <xc-form-item label="上级模块">
                                            <input type="hidden" name="parentId" :value="module.moduleId">
                                            <input type="text" name="parentName" :value="module.label" class="xc-input xc-input-disabled" disabled/>
                                        </xc-form-item>
                                        <xc-form-item label="模块名称" required :error="errors.first('moduleName','addChild')">
                                            <input type="text" name="moduleName" class="xc-input" v-validate="'required'" data-vv-as="模块名称"/>
                                        </xc-form-item>
                                    </div>
                                    <div class="xc-form-inline">
                                        <xc-form-item label="模块类别" required :error="errors.first('type','addChild')">
                                            <label class="xc-checkbox-wrap" v-if="module.level==0">
                                                <input type="radio" name="type" class="xc-radio" value="1" :checked="true" @click="selectType($event)" v-validate="'required'" data-vv-as="模块类别"/>
                                                <span class="xc-checkbox-label">菜单</span>
                                            </label>
                                            <label class="xc-checkbox-wrap">
                                                <input type="radio" name="type" class="xc-radio" value="2" :checked="!isShow"  @click="selectType($event)" v-validate="'required'" data-vv-as="模块类别"/>
                                                <span class="xc-checkbox-label">按钮</span>
                                            </label>
                                        </xc-form-item>
                                        <xc-form-item label="状态" required :error="errors.first('status','addChild')">
                                            <label class="xc-checkbox-wrap">
                                                <input type="radio" name="status" class="xc-radio" :checked="true" value="1" v-validate="'required'" data-vv-as="状态"/>
                                                <span class="xc-checkbox-label">启用</span>
                                            </label>
                                            <label class="xc-checkbox-wrap">
                                                <input type="radio" name="status" class="xc-radio" value="0" v-validate="'required'" data-vv-as="状态"/>
                                                <span class="xc-checkbox-label">禁用</span>
                                            </label>
                                        </xc-form-item>
                                    </div>

                                    <xc-form-item label="备注">
                                        <input type="text" name="moduleDesc" class="xc-input"/>
                                    </xc-form-item>
                                    <div class="xc-form-inline">
                                        <xc-form-item label="url" :error="errors.first('url','addChild')">
                                            <input type="text" name="url" placeholder="例如/a/b/c" class="xc-input" v-validate="'href'" data-vv-as="url"/>
                                        </xc-form-item>
                                    </div>
                                    <template v-if="isShow && false">
                                        <div class="xc-form-inline">
                                            <xc-form-item label="icon" >
                                                <input type="hidden" name="defaultIcon" class="xc-input"/>
                                                <xc-upload
                                                    :fileList.sync="inactive"
                                                    :beforeUpload="beforeUpload"
                                                    :uploadSuccess="uploadSuccess"
                                                    type="3"
                                                    accept="image/*"
                                                    :url="uploadUrl"
                                                />
                                            </xc-form-item>
                                            <xc-form-item label="选中的icon" >
                                                <input type="hidden" name="lightIcon" class="xc-input"/>
                                                <xc-upload
                                                    :fileList.sync="active"
                                                    :beforeUpload="beforeUpload"
                                                    :uploadSuccess="uploadSuccess"
                                                    type="3"
                                                    accept="image/*"
                                                    :url="uploadUrl"
                                                />
                                            </xc-form-item>
                                        </div>
                                    </template>
                                </form>
                            </div>
                            <div class="xc-modal-footer xc-flex-center">
                                <div class="xc-btn-group">
                                    <button type="button" class="xc-btn xc-btn-primary" @click="addChild">确定</button>
                                    <button type="button" class="xc-btn xc-btn-default" @click="modalName=null">取消</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--编辑-->
            <div class="xc-modal xc-modal-dialog" v-if="modalName=='edit'">
                <div class="xc-modal-mask" @click="modalName==null">
                    <div class="xc-modal-wrap xc-anim-scaleIn">
                        <div class="xc-modal-content">
                            <div class="xc-modal-header">
                                <div class="xc-modal-title">编辑</div>
                                <div class="xc-modal-close" @click="modalName=null"></div>
                            </div>
                            <div class="xc-modal-body">
                                <form class="xc-form" name="edit" data-vv-scope="edit">
                                    <div class="xc-form-inline">
                                        <input type="hidden" name="moduleId" :value="module.moduleId"/>
                                        <xc-form-item label="上级模块">
                                            <input type="hidden" name="parentId" :value="module.pid">
                                            <input type="text" name="parentName" :value="module.pName" class="xc-input xc-input-disabled" disabled/>
                                        </xc-form-item>
                                        <xc-form-item label="模块名称" required :error="errors.first('moduleNmme','edit')">
                                            <input type="text" name="moduleName" v-model="module.label" class="xc-input" v-validate="'required'" data-vv-as="模块名称"/>
                                        </xc-form-item>
                                    </div>
                                    <div class="xc-form-inline">
                                        <xc-form-item label="模块类别" required :error="errors.first('type','edit')">
                                            <label class="xc-checkbox-wrap" v-if="module.type==1">
                                                <input type="radio" name="type" :checked="module.type==1" class="xc-radio" value="1" @click="selectType($event)" v-validate="'required'" data-vv-as="模块类别"/>
                                                <span class="xc-checkbox-label">菜单</span>
                                            </label>
                                            <label class="xc-checkbox-wrap" v-if="module.type==2">
                                                <input type="radio" name="type"  :checked="module.type==2" class="xc-radio" value="2" @click="selectType($event)" v-validate="'required'" data-vv-as="模块类别"/>
                                                <span class="xc-checkbox-label">按钮</span>
                                            </label>
                                        </xc-form-item>
                                        <xc-form-item label="状态" required :error="errors.first('status','edit')">
                                            <label class="xc-checkbox-wrap">
                                                <input type="radio" name="status" :checked="module.status==1" class="xc-radio" value="1" v-validate="'required'" data-vv-as="状态"/>
                                                <span class="xc-checkbox-label">启用</span>
                                            </label>
                                            <label class="xc-checkbox-wrap">
                                                <input type="radio" name="status" :checked="module.status==0" class="xc-radio" value="0" v-validate="'required'" data-vv-as="状态"/>
                                                <span class="xc-checkbox-label">禁用</span>
                                            </label>
                                        </xc-form-item>
                                    </div>
                                    <xc-form-item label="备注">
                                        <input type="text" name="moduleDesc" v-model="module.moduleDesc" class="xc-input"/>
                                    </xc-form-item>
                                    <div class="xc-form-inline">
                                        <xc-form-item label="url" :error="errors.first('url','edit')">
                                            <input type="text" name="url" placeholder="例如/a/b/c" v-model="module.url" class="xc-input" v-validate="'href'" data-vv-as="url"/>
                                        </xc-form-item>
                                    </div>
                                    <template v-if="isShow && module.level==0">
                                        <div class="xc-form-inline">
                                            <xc-form-item label="icon" >
                                                <input type="hidden" name="defaultIcon" class="xc-input"/>
                                                <xc-upload
                                                    :fileList.sync="inactive"
                                                    :beforeUpload="beforeUpload"
                                                    :uploadSuccess="uploadSuccess"
                                                    type="3"
                                                    accept="image/*"
                                                    :url="uploadUrl"
                                                />
                                            </xc-form-item>
                                            <xc-form-item label="选中的icon" >
                                                <input type="hidden" name="lightIcon" class="xc-input"/>
                                                <xc-upload
                                                    :fileList.sync="active"
                                                    :beforeUpload="beforeUpload"
                                                    :uploadSuccess="uploadSuccess"
                                                    type="3"
                                                    accept="image/*"
                                                    :url="uploadUrl"
                                                />
                                            </xc-form-item>
                                        </div>
                                    </template>
                                </form>
                            </div>
                            <div class="xc-modal-footer xc-flex-center">
                                <div class="xc-btn-group">
                                    <button type="button" class="xc-btn xc-btn-primary" @click="edit">确定</button>
                                    <button type="button" class="xc-btn xc-btn-default" @click="modalName=null">取消</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import user from "@/api/module"
    import "@/libs/vee-validate";
    import "@/utils/form-format"
    export default {
        name: "ModuleList",
        data(){
            return{
                list:[],    //模块列表
                modalName:null,
                module:{},  //当前模块,
                showTreeEdit:false,
                isShow:true,
                uploadUrl: '/uploadfile',
                inactive:[], //默认icon
                active:[]   //选中的icon
            }
        },
        created(){
            var _this=this;
            this.getModules();
            document.body.addEventListener("click",function (e) {
                e.stopPropagation();
                _this.showTreeEdit=false;
            })
        },
        methods:{
            selectType(e){
                var target=e.target;
                var value=target.value;
                if(value==2){
                    this.isShow=false;
                }else {
                    this.isShow=true;
                }
            },
            //上传之前
            beforeUpload(res){
               /* var index=res.name.lastIndexOf(".");
                var type=res.name.substring(index).toLowerCase();
                var str=".jpg,.ico,.png";
                if(str.indexOf(type)==-1){
                    this.$message.error("文件格式不正确");
                    return -1;
                }*/
            },
            //上传完成
            uploadSuccess: function (res) {
               /* console.log(res);
                console.log(this.inactive)
                debugger;
                document.getElementsByName("icon")[0].value=res.data[0].url;*/
            },
            getModules(){
                var _this=this;
                //获取模块列表
                user.listAllModule().then(function (success) {
                    _this.list=success.data;
                })
            },
            //    右键点击的回调
            rightClick:function (data) {
                var item=data.data;
                var parent,pName;
                parent = this.$refs.groupTree.objTree[item.treeParentId];
                if(parent){
                    pName=parent.label;
                }
                this.module={pName:pName,...item};
                this.showTreeEdit=true;
                var menu=this.$refs.treeEdit;
                var x=data.event.x + 10;
                var y=data.event.y + 10;
                menu.style.left=x + "px";
                menu.style.top=y + 'px';
            },
            //右键菜单操作
            openEditGroup(type){
                var _this=this;
                this.inactive=[];
                this.active=[];
                this.isShow=true;
                //不能添加3级菜单
                if(this.module.level>1){
                    this.isShow=false;
                }
                this.showTreeEdit=false;
                switch(type){
                    case "add":
                        this.modalName="add";
                        break;
                    case "addChild":
                        this.modalName="addChild";
                        //不能添加3级菜单
                        if(this.module.level==1){
                            this.isShow=false;
                        }
                        break;
                    case "edit":
                        this.modalName="edit";
                        if(this.module.type==2){
                            this.isShow=false;
                        }
                        if(this.module.defaultIcon){
                            var obj1={
                                file:this.module.defaultIcon,
                                url:this.module.defaultIcon,
                            }
                            this.inactive.push(obj1)
                        }
                        if(this.module.lightIcon){
                            var obj2={
                                file:this.module.lightIcon,
                                url:this.module.lightIcon,
                            }
                            this.active.push(obj2)
                        }
                        break;
                    case "delete":
                        this.$xc.confirm({
                            title:"系统提示",
                            msg:"确认删除？"
                        }).then(function () {
                            var obj={
                                moduleId:_this.module.moduleId,
                            }
                            user.delete(obj).then(function (success) {
                                _this.$message.success("删除成功");
                                _this.getModules();
                            })
                        })
                        break;
                    default:
                        break;
                }
            },
        //    添加模块
            add(){
                var _this = this;
                var myForm = document.add;
                if(this.module.level==0){
                    if(this.inactive.length){
                        myForm.defaultIcon.value=this.inactive[0].url;
                    }
                    if(this.active.length){
                        myForm.lightIcon.value=this.active[0].url;
                    }
                }
                // 验证器命名空间
                const scope = 'add';

                this.$validator.validateAll(scope).then(validate => {
                    if (validate) {
                        return this.$formFormat(myForm);
                    } else {
                        let error = this.errors.items[0].msg;
                        return false;
                    }
                }).then(formData => {
                    if (formData) {
                        user.save(formData).then(function (success) {
                            _this.$message.success("添加成功");
                            _this.modalName=null;
                            _this.getModules();
                        }).catch(function (error) {
                            console.log(error)
                        })
                    }
                })
            },
        //    添加子菜单
            addChild(){
                var _this = this;
                var myForm = document.addChild;
                // 验证器命名空间
                const scope = 'addChild';

                this.$validator.validateAll(scope).then(validate => {
                    if (validate) {
                        return this.$formFormat(myForm);
                    } else {
                        let error = this.errors.items[0].msg;
                        return false;
                    }
                }).then(formData => {
                    if (formData) {
                        user.save(formData).then(function (success) {
                            _this.$message.success("添加成功");
                            _this.modalName=null;
                            _this.getModules();
                        }).catch(function (error) {
                            console.log(error)
                        })
                    }
                })
            },
        //    编辑模块
            edit(){
                var _this = this;
                var myForm = document.edit;
                if(this.module.level==0){
                    if(this.inactive.length){
                        myForm.defaultIcon.value=this.inactive[0].url;
                    }
                    if(this.active.length){
                        myForm.lightIcon.value=this.active[0].url;
                    }
                }
                // 验证器命名空间
                const scope = 'edit';

                this.$validator.validateAll(scope).then(validate => {
                    if (validate) {
                        return this.$formFormat(myForm);
                    } else {
                        let error = this.errors.items[0].msg;
                        return false;
                    }
                }).then(formData => {
                    if (formData) {
                        user.update(formData).then(function (success) {
                            _this.$message.success("修改成功");
                            _this.modalName=null;
                            _this.getModules();
                        }).catch(function (error) {
                            console.log(error)
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .modules{
        width: 300px;
        padding: 20px;
        border: 1px solid #e6e6e6;
        .head{
            display: flex;
            margin-bottom: 20px;
            .btn{
                width: 20px;
                height: 20px;
                text-align: center;
                line-height: 20px;
                border: 1px solid #e6e6e6;
                border-right: none;
                cursor: pointer;
                &:last-of-type{
                    border-right: 1px solid #e6e6e6;
                }
            }
        }
        .body{
            .xc-tree-edit {
                position: fixed;
                background: #fff;
                border: solid 1px #eee;
                border-radius: 8px;
                padding: 10px 16px;
                box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.05);
            }

            .xc-tree-edit ul li {
                line-height: 30px;
                cursor: pointer;
            }

            .xc-tree-edit ul li:hover {
                color: #507dde;
            }
        }
    }
</style>
